export default "__VITE_ASSET__CvlVNpwN__"